/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Key_AnthropicInputs */

const en_ai_key_anthropic = /** @type {(inputs: Ai_Key_AnthropicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anthropic API key`)
};

const de_ai_key_anthropic = /** @type {(inputs: Ai_Key_AnthropicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anthropic-API-Schlüssel`)
};

/**
* | output |
* | --- |
* | "Anthropic API key" |
*
* @param {Ai_Key_AnthropicInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_key_anthropic = /** @type {((inputs?: Ai_Key_AnthropicInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Key_AnthropicInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_key_anthropic(inputs)
	return en_ai_key_anthropic(inputs)
});